import FooterNav from '../components/FooterNav';

const CarFeature = () =>{
    return(
        <div className={"container landing fullscreen experience"}>
            <div className="content">
                <div className="page-logo lg nissan">NISSAN</div>
                <div className="content-text center">
                    <h2>TECHNOLOGY</h2>
                    <h3>Feature</h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                    <a href="https://nissanusa.com" target="_blank" className="btn transparent">LEARN MORE</a>
                </div>
            </div>
            
            <FooterNav currentPage="car-feature" 
                prev={{text:"BACK", url:"/experience"}} 
                centerText = "CHECK BACK SOON TO PLAY THE EV DRIVING CHALLENGE"
                    />
                
        </div>
    )
}

export default CarFeature;